import { createExperimentHook } from '@prisjakt/ui-experiment';

export const useAlertPriceStepExperiment = createExperimentHook(
  'alert-price-step',
  false,
  { showAlertPriceStep: true }
);

export const useAlertStoreRatingExperiment = createExperimentHook(
  'alert-store-rating',
  false,
  { showAlertStoreRating: true }
);

export const useProductPageHeaderCompareLinkExperiment = createExperimentHook(
  'product-page-header-compare-link',
  { show: false },
  { show: { show: true } }
);
